export const calenderSlot_style = {
  CalendarSx: {
    fontSize: '14px',
    color: 'text.primary',
    fontWeight: 'medium',
  },
  dateSelectionWrapperSx: {
    overflowY: 'scroll',
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: 1.5,
    mt: 1,
  },
  totalSx: {
    backgroundColor: '#fff',
    width: ' 100%',
    margin: '0px auto',
    '& .MuiTabs-root': {
      minHeight: 0,
      borderRadius: '8px',
    },
  },

  rootDateSx: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'minmax(auto, 2%) minmax(auto, 96%) minmax(auto, 2%)',
  },
  stickySx: {
    // position: '-webkit-sticky',
    position: 'sticky',
    top: '-18px',
    backgroundColor: '#fff',
    zIndex: 3,
  },
  dateSelectionSx: {
    px: 0.8,
    py: 1.8,
    textAlign: 'center',
  },

  timeSelectionSx: {
    pr: 1,
    py: 0.8,
    textAlign: 'center',
    borderRadius: '8px',
  },

  iconWithTimeSelectionSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    cursor: 'pointer',
    px: 0.1,
  },

  pastButton: {
    backgroundColor: 'primaryGreyishTints.100',
    fontSize: '14px',
    fontWeight: 'medium',
    borderRadius: '24px',
    opacity: '0.5',
  },
  todayButton: {
    backgroundColor: 'orangeTints.50',
    fontSize: '14px',
    fontWeight: 'medium',
    borderRadius: '24px',
    border: '2px solid #EB6D13',
  },

  selectTimeButton: {
    backgroundColor: 'orangeTints.50',
    color: 'orangeTints.600',
    border: '1px solid',
  },

  unSelectIconChange: {
    color: 'divider',
    fontSize: '14px',
    fontWeight: 'medium',
  },
  SelectIconChange: {
    color: 'orangeTints.600',
    fontSize: '14px',
    fontWeight: 'medium',
  },

  pastTimeButton: {
    backgroundColor: 'primaryGreyishTints.100',
    fontSize: '8px',
    fontWeight: 'medium',
    opacity: 0.5,
  },
  unSelectTimeButton: {
    backgroundColor: '#fff',
    fontSize: '14px',
    fontWeight: 'medium',
    border: '1px solid',
    borderColor: '#007965',
  },
  unSelectButton: {
    backgroundColor: 'primaryGreyishTints.100',
    fontSize: '14px',
    fontWeight: 'medium',
    borderRadius: '24px',
  },
  availableTextSx: {
    fontSize: '14px',
    fontWeight: 'medium',
    color: 'text.primary',
    mt: 2,
    ml: 1.6,
  },
  timeTextSx: {
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
  },
  tabSx: {
    '&.Mui-selected': {
      color: '#fff',
      backgroundColor: 'orangeTints.600',
      borderRadius: '8px',
      fontSize: '14px',
      p: '6px 0px',
      fontWeight: 600,
    },
  },
  underTabCalenderStyle: {
    backgroundColor: 'orangeTints.50',
    '& .MuiTabs-indicator': {
      backgroundColor: 'none',
      height: '0',
      px: 3,
    },
    '& .MuiTabs-flexContainer': {
      display: 'grid',
      gridTemplateColumns: 'repeat(4,1fr)',
      gap: '4px',
      boxSizing: 'border-box',
      m: 0.5,
      overflow: 'overlay',
      '::-webkit-scrollbar-thumb': {
        display: 'none',
      },
    },
  },
};
